import React from 'react';
import { UpdatePaymentMethodFundingAccount, UpdatePaymentMethodFundingAccountHint } from './components';
import {} from './UpdatePaymentMethodFundingAccounts.types';
const UpdatePaymentMethodFundingAccounts = ({ fundingAccounts, partnership, }) => (React.createElement("div", { className: "update-payment-method-form-international__funding-accounts" },
    fundingAccounts.map((fundingAccount) => (React.createElement(UpdatePaymentMethodFundingAccount, { fundingAccount: fundingAccount, key: fundingAccount.id, partnership: partnership }))),
    React.createElement(UpdatePaymentMethodFundingAccountHint, null)));
export default UpdatePaymentMethodFundingAccounts;
